import { ENDPOINT } from './meta.api';

const EMPTY_RESULT = {
    hits: [],
    nbHits: 0,
    nbPages: 0,
    page: 0,
    processingTimeMS: 0,
    query: '',
};

export function createProxySearchClient() {
    return {
        async search(requests) {
            if (requests.every(({ params }) => !params.query)) {
                return Promise.resolve({
                    results: requests.map(() => ({ ...EMPTY_RESULT })),
                });
            }

            const res = await fetch(`${ENDPOINT}/search/algolia/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ requests }),
            });
            if (!res.ok) {
                const body = await res.json().catch(() => null);
                throw new Error(body?.message || 'Search request failed');
            }
            return await res.json();
        },
    };
}

export async function sendAlgoliaInsightEvent(events) {
    const validEvents = events.filter((e) => e.userToken);
    if (!validEvents.length) return;

    try {
        const res = await fetch(`${ENDPOINT}/search/algolia/insights/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ events: validEvents }),
        });
        if (!res.ok) {
            console.error(
                `Failed to send Algolia insight event: HTTP ${res.status} ${res.statusText}`,
            );
        }
        return res;
    } catch (err) {
        console.error('Failed to send Algolia insight event:', err);
    }
}
